import { updateReportConstructor } from "store/report-constructor";
import { header, getLanguage, checkFilters } from "./header";

const report = header('report/api/v1/report-templates');

const getAuth = () =>{
    let authorization = localStorage.getItem('auth')
    report.defaults.headers.common['Authorization'] =`Bearer ${authorization}` 
}

const setLanguage = () => {
    report.defaults.headers.common['Accept-Language'] = getLanguage()
}

export const ReportConstrucorService = {
    getReportTemplates(pageIndex = 0, pageSize = 150, sortField="CREATED_AT", sortDirection="DESC", status=null, search=null){        
        setLanguage();
        getAuth();
        return report.get(`?pageIndex=${pageIndex}&pageSize=${pageSize}&sortField=${sortField}&sortDirection=${sortDirection}`).then(response => {
            return response.data
        })
    },
    getReportTemplate(templateId){
        setLanguage();
        getAuth();
        return report.get(`/${templateId}`).then(response => {
            return response.data;
        })
    },
    createReportConstructorTemplate(name, parameters){
        setLanguage();
        getAuth();
        return report.post(``, {name, parameters}).then(response => {
            return response.data;
        })
    },
    updateReportConstructor(id, name, parameters = {}){
        setLanguage();
        getAuth();
        return report.put(`/${id}`, {name, parameters}).then(response => {

        });
    },
    updateReportConstructorComponents(id, parameters){
        setLanguage();
        getAuth();
        return report.put(`/${id}/components`, [...parameters], {headers: { 'Content-Type': 'application/json'}, data: []}).then(response => {
            return response.data;
        })
    },
    deleteReportTemplate(id){
        setLanguage();
        getAuth();
        return report.delete(`${id}`).then(response => {
            return response.data;
        })
    }
}